var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNum4White(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 177.15 224.76",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M0,175.79v-35.02c10.65-10.65,20.74-21.81,30.26-33.49,9.52-11.67,18.36-23.52,26.52-35.53,8.16-12.01,15.47-24.08,21.93-36.21,6.46-12.12,11.84-23.97,16.15-35.53h54.06v224.76h-30.94V24.14h-2.72c-7.26,16.78-15.36,32.47-24.31,47.09-8.96,14.62-18.53,28.11-28.73,40.46-10.2,12.36-20.63,23.86-31.28,34.51v3.06h146.21v26.52H0Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNum4White);
export default __webpack_public_path__ + "static/media/num_4_white.29773a923a1ab6c7234cfa62d36c336e.svg";
export { ForwardRef as ReactComponent };